
export default function Trust() {
  const stores = [
    { name: 'Sonoma Market', logo: 'https://public.readdy.ai/ai/img_res/aced515e4a2ff1765f02b2a852a18a33.jpg' },
    { name: 'Valley Foods', logo: 'https://readdy.ai/api/search-image?query=Professional%20minimalist%20logo%20for%20local%20food%20retailer%20on%20white%20background%20clean%20simple%20design%20with%20modern%20typography%20and%20professional%20appearance&width=200&height=100&seq=store-logo-002&orientation=landscape' },
    { name: 'Petaluma Corner Store', logo: 'https://readdy.ai/api/search-image?query=Simple%20clean%20logo%20design%20for%20neighborhood%20corner%20store%20on%20white%20background%20minimalist%20professional%20branding%20with%20modern%20look&width=200&height=100&seq=store-logo-003&orientation=landscape' },
    { name: 'Healdsburg General', logo: 'https://readdy.ai/api/search-image?query=Minimalist%20professional%20logo%20for%20general%20store%20on%20white%20background%20clean%20typography%20based%20design%20with%20modern%20aesthetic&width=200&height=100&seq=store-logo-004&orientation=landscape' }
  ];

  const placements = [
    {
      image: 'https://readdy.ai/api/search-image?query=Professional%20retail%20store%20shelf%20display%20with%20organized%20snack%20products%20in%20clean%20modern%20independent%20store%20setting%20showing%20well%20stocked%20shelves%20with%20proper%20product%20placement%20and%20neat%20arrangement&width=600&height=400&seq=placement-001&orientation=landscape',
      alt: 'Store Placement 1'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20counter%20display%20rack%20with%20snack%20products%20in%20independent%20retail%20store%20showing%20professional%20merchandising%20and%20product%20organization%20in%20bright%20natural%20lighting&width=600&height=400&seq=placement-002&orientation=landscape',
      alt: 'Store Placement 2'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Well%20organized%20retail%20shelf%20with%20packaged%20snack%20products%20in%20modern%20independent%20store%20showing%20professional%20product%20placement%20and%20inventory%20management%20with%20clean%20aesthetic&width=600&height=400&seq=placement-003&orientation=landscape',
      alt: 'Store Placement 3'
    }
  ];

  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Built for Independent Stores
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Local snack distribution for Sonoma County retailers.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stores.map((store, index) => (
            <div
              key={index}
              className="flex items-center justify-center p-6 bg-gray-50 rounded-lg"
            >
              <img
                src={store.logo}
                alt={store.name}
                className="w-full h-12 object-contain object-center grayscale hover:grayscale-0 transition-all"
              />
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {placements.map((placement, index) => (
            <div key={index} className="rounded-lg overflow-hidden">
              <div className="aspect-[3/2] w-full overflow-hidden">
                <img
                  src={placement.image}
                  alt={placement.alt}
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto bg-gray-50 p-10 rounded-lg">
          <div className="flex items-start gap-4 mb-4">
            <i className="ri-double-quotes-l text-4xl text-gray-900"></i>
          </div>
          <p className="text-xl text-gray-800 leading-relaxed mb-6 italic">
            Sonoma Routes transformed how we manage our snack section. They started small, tested what worked, and now we have a rotating selection that actually sells. No waste, no hassle, just products our customers want.
          </p>
          <div className="flex items-center gap-4">
            <div>
              <p className="font-bold text-gray-900">Sarah Mitchell</p>
              <p className="text-sm text-gray-600">Owner, Healdsburg General Store</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
